import styled, { createGlobalStyle } from "styled-components";
import { Table } from "antd";

export const Container = styled.div`
  width: 100%;

  #ant-modal-body {
    display: none;
  }
`;

export const Tools = styled.div`
  width: 100%;
  margin-top: 5vh;
  margin-bottom: 3vh;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 10px;
`;

export const LeftContentWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
`;

export const SearchContainer = styled.form`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;
`;

export const RightAlignedButtons = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;


export const SummaryCardsContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;

  @media (max-width: 1100px) {
    gap: 12px;
  }
`;

export const SummaryCard = styled.div<{ color?: string }>`
  position: relative;
  flex: 1;
  min-width: 180px;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-top: 4px solid ${({ color }) => color || '#1890ff'};
  border-radius: 6px;
  padding: 14px 18px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.07);

  @media (max-width: 1100px) {
    min-width: calc(50% - 8px);
    flex: 1 1 calc(50% - 8px);
    padding: 12px 14px;
  }

  @media (max-width: 600px) {
    min-width: 100%;
    flex: 1 1 100%;
  }

  .card-label {
    font-size: 0.72rem;
    font-weight: 600;
    color: #888;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    margin-bottom: 6px;
  }

  .card-value {
    font-size: calc(1.15rem + 8px);
    font-weight: 700;
    color: ${({ color }) => color || '#1890ff'};
    white-space: nowrap;

    @media (max-width: 1100px) {
      font-size: 1.3rem;
      white-space: normal;
      word-break: break-word;
    }
  }

  .card-subvalue {
    position: absolute;
    left: 18px;
    bottom: 6px;
    font-size: 0.7rem;
    font-weight: 600;
    color: #888;
    line-height: 1;

    strong {
      color: #555;
      font-weight: 700;
    }

    @media (max-width: 1100px) {
      left: 14px;
    }
  }
`;

export const DivTable = styled.div`
  margin: 0 auto;
padding-bottom: 20px;

  .ant-btn {
    /* Se precisar de algum estilo específico para botões, adicione aqui */
  }

  .ant-table-cell {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const MenuContainer = styled.div`
  select {
    padding: 8px 12px;
    font-size: 16px;
    border-radius: 4px;
    border: 1px solid #dcdcdc;
    background-color: #ffffff;
    color: #333333;
    outline: none;
    cursor: pointer;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;

    &:focus {
      border-color: #007bff;
      box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
    }

    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    &::-webkit-inner-spin-button,
    &::-webkit-calendar-picker-indicator,
    &::-ms-expand {
      display: none;
    }

    &::-webkit-dropdown-list,
    &::-moz-focus-inner {
      background-color: #ffffff;
      border: 0;
      padding: 0;
    }
  }
`;

export const DatePickerInput = styled.input`
  height: 43.15px;
  width: 200px;
  padding: 4px 11px;
  font-size: 14px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  outline: none;
  box-sizing: border-box;

  &:focus {
    border-color: #40a9ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }
`;

export const TableStyles = createGlobalStyle`
  /* Estilos para o cabeçalho da tabela */
  .ant-table-thead > tr > th {
    font-size: 0.8rem;
    padding: 10px;
    font-weight: bold; /* Opcional: para manter o cabeçalho em negrito */
  }

  /* Estilos para o corpo da tabela */
  .ant-table-tbody > tr > td {
    font-size: 0.7rem; /* Reduz a fonte das células do corpo */
    padding: 8px 10px;
  }
`;

// Remaining unused styled components from original file.
export const divButton = styled.div`
  margin: 0 0 0 2rem;
`;

export const Button = styled.button`
  border: none;
  background-color: #70e000;
  border-radius: 6px;
  padding: 0.5rem 2rem;
  color: white;
  cursor: pointer;
  transition: all 0.3s;
  white-space: nowrap;
  &:hover {
    opacity: 0.7;
  }
`;

export const ContainerImage = styled.div`
  margin-left: 10%;
  width: fit-content;
  img {
    width: 160px;
  }
  span {
    margin-left: 20px;
    font-size: 0.8rem;
    font-weight: 700;
  }
`;

export const ContainerWord = styled.div`
  margin-right: auto;
  margin-left: auto;
  width: fit-content;
  font-weight: 700;
  font-size: 24px;
`;

export const ModalHeader = styled.div`
  overflow: auto;
  margin-bottom: 1rem;
`;

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 65vh;
  overflow: auto;
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Actions = styled.div`
  display: flex;
  gap: 10px;
`;

export const Typography = styled.div`
  p {
    color: #000;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: normal;
    white-space: nowrap;
    margin: 0;
  }
`;

export const RoundedModalStyle = createGlobalStyle`
  .my-custom-rounded-modal .ant-modal-content {
    overflow: hidden; /* Garante que o conteúdo dentro do modal também respeite o arredondamento */
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 32px 48px 0 rgba(0, 0, 0, 0.35);
    backdrop-filter: blur(7px);
    border-radius: 20px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    color: #333; /* opcional */
    font-weight: 700;
    font-size: 14px;
    line-height: 1.1;
    opacity: 1;
  }
`;

export const CopyOutlined = styled.span`
  display: inline-block;
  width: 1em;
  height: 1em;
  vertical-align: -0.125em;
  fill: currentColor;
  overflow: hidden;
  font-size: 16px;
  color: #1890ff;

  &::before {
    content: "📋";
  }
`;

/* A tabela preenche toda a altura do modal via flex (sem número mágico), para a linha de
   Total (summary fixed) ficar colada no rodapé mesmo com poucas parcelas — sem cortar. */
export const ModalParcelas = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  .ant-table-wrapper {
    flex: 1;
    min-height: 0;
    display: flex;
  }

  .ant-spin-nested-loading {
    flex: 1;
    min-height: 0;
    width: 100%;
  }

  .ant-spin-container {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .ant-table {
    flex: 1;
    min-height: 0;
  }

  .ant-table-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  .ant-table-header {
    flex: 0 0 auto;
  }

  .ant-table-body {
    flex: 1 1 auto;
    min-height: 0;
    max-height: none !important;
    overflow: auto !important;
  }
`;